// MeetingTitle.js
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { getLocaleDateWithTimeCustomV2, getMeetingTitleByMeetingInstUnit, getUserFullName } from "app/utils/appHelpers";
import config from "config";
import React from "react";
import { useSelector } from "react-redux";
import { useTemplateFontSettings } from 'styles/templateFontSettings';

const MeetingTitleBox = ({ meeting, toggleFullScreen, onClose, isFullScreen, type = "preview" }) => {

    

    const userList = useSelector((state) => state.user.data || []);
    if (!meeting) return null;

    const user = userList.find((user) => user.id === meeting.adminUserId);


    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                width: "100%",
                maxHeight: "50px",
                p: 0,
            }}
        >
            <Box sx={{ width: "100%", position: "relative" }}>
                <Typography variant="h6" sx={{ textAlign: "center", m: 0 }}>
                    {getMeetingTitleByMeetingInstUnit(meeting)}
                </Typography>
                {type === "preview" && (
                    <Box
                        sx={{
                            position: "absolute",
                            right: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            gap: 1,
                            alignItems: "center",
                        }}
                    >
                        <Button variant="contained" onClick={toggleFullScreen} size="small" sx={{  }}>
                            {isFullScreen ? "Ekranı Küçült" : "Tam Ekran"}
                        </Button>
                        <IconButton onClick={onClose} size="small" sx={{  }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                )}
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    flexWrap: "wrap",
                    width: "100%",
                }}
            >
                <Typography variant="caption" sx={{  }}>
                    Sayı: {meeting.meetingNo}
                </Typography>
                <Typography variant="caption" sx={{  }}>
                    Tarih: {getLocaleDateWithTimeCustomV2("tr", meeting.pdate)}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 0 }}>
                    <Typography variant="caption" sx={{ m: 0 }}>
                        Toplantı Şekli: {meeting.meetingMode}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                    <Typography variant="caption" sx={{ m: 0 }}>
                        Toplantı Yöneticisi:
                    </Typography>
                    <Avatar
                        sx={{ height: 25, width: 25 }}
                        alt={user?.name || ""}
                        src={
                            user?.profileImageUrl
                                ? `${config.userAuthApiUrl}${user.profileImageUrl}`
                                : undefined
                        }
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl;
                        }}
                    />

                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 0 }}>
                        <Typography variant="caption" sx={{ m: 0 }}>
                            {getUserFullName(user)}
                        </Typography>
                    </Box>


                </Box>
            </Box>
        </Box>
    );
};

export default MeetingTitleBox;
